import React from 'react'

import { observer } from 'mobx-react-lite'

const Topic = observer(({ label, link }) => {
	return (
		<div className="topic">
			<a target="_blank" href={link}>
				{label}
			</a>
			<style jsx>{`
				div {
					margin-bottom: 1.25rem;
				}
				a {
					color: #000;
					font-size: var(--font--xs);
				}
				a:hover {
					text-decoration: underline;
				}
			`}</style>
		</div>
	)
})

export default Topic
